import { Navigate, RouteObject } from 'react-router-dom';
import BasicLayout from '@/layout/BasicLayout';
import PlanShareLayout from '@/layout/PlanShareLayout';

// tab
import Home from '@/pages/home';
import Nav from '@/pages/nav';
import PadInfo from '@/pages/user/pad-info';
import ServiceRecord from '@/pages/service-record';

// user
import SearchMember from '@/pages/user/search-member';
import MemberDetail from '@/pages/user/member-detail';
import AddMember from '@/pages/user/member-management/add-member';
import EditMember from '@/pages/user/member-management/edit-member';
import DeviceBinding from '@/pages/user/device-binding';
import PageTest from '@/pages/user/page-test';
import BodyChange3D from '@/pages/user/body-change-3d';

// service
import NoService from '@/pages/service/no-service';
import ActionTest from '@/pages/service/action-test';
import AddService from '@/pages/service/add-service';
import ServiceDetail from '@/pages/user/service-detail';
import MassageSetting from '@/pages/service/massage-setting';
import MassageSettingMox from '@/pages/service/massage-setting-mox';
import MassageControl from '@/pages/service/massage-control';
import ImmersionMode from '@/pages/service/immersion-mode';
import ActionRetest from '@/pages/service/action-retest';
import BodyMeasurement from '@/pages/service/body-measurement';
import BodyReMeasurement from '@/pages/service/body-remeasurement';

// device
import DeviceManagement from '@/pages/device/device-management';
import PosAssist from '@/pages/device/pos-assist';
import DeviceNetworkConfig from '@/pages/device/device-network-config';
import IssueDetectTool from '@/pages/device/issue-detect-tool';

// help
import HelpHomePage from '@/pages/help';
import HelpFeedback from '@/pages/help/help-feedback';
import IssueReport from '@/pages/help/issue-report';
import FeedbackProgress from '@/pages/help/feedback-progress';
import UseSkills from '@/pages/help/use-skills';
import VersionUpdateNotice from '@/pages/help/version-update-notice';
import IframeContent from '@/pages/help/iframe-content';

// 会员记录详情
import MemberRecordDetail from '@/pages/service-record/components/MemberRecordDetail';

// AI问诊
import AIConsultation from '@/pages/ai-consultation';
import ShareResultPlan from '@/pages/ai-consultation/components/share-result-plan';

/**
 * 添加新路由时，需要去BasicLayout组件注册PAD端系统返回事件处理逻辑
 */
const routerConfig: RouteObject[] = [
  {
    path: '/share',
    element: <PlanShareLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="/share/ai-consultation" replace={true} />,
      },
      {
        path: 'ai-consultation',
        element: <ShareResultPlan />,
      },
    ],
  },
  {
    path: '/',
    element: <BasicLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="/home" replace={true} />,
      },
      {
        path: 'home',
        element: <Home />,
      },
      {
        path: 'pad-info',
        element: <PadInfo />,
      },
      {
        path: '/no-service',
        element: <NoService />,
      },
      {
        path: '/page-test',
        element: <PageTest />,
      },
      {
        path: 'user/search-member',
        element: <SearchMember />,
      },
      {
        path: 'user/member-detail',
        element: <MemberDetail />,
      },
      {
        path: 'user/add-member',
        element: <AddMember />,
      },
      {
        path: 'user/edit-member',
        element: <EditMember />,
      },
      {
        path: 'user/service-detail',
        element: <ServiceDetail />,
      },
      {
        path: 'user/body-change-3d',
        element: <BodyChange3D />,
      },
      {
        path: 'service/add-service',
        element: <AddService />,
      },
      {
        path: 'service/action-test',
        element: <ActionTest />,
      },
      {
        path: 'service/action-retest',
        element: <ActionRetest />,
      },
      {
        path: 'service/body-measurement',
        element: <BodyMeasurement />,
      },
      {
        path: 'service/body-remeasurement',
        element: <BodyReMeasurement />,
      },
      {
        path: 'service/massage-setting',
        element: <MassageSetting />,
      },
      {
        path: 'service/massage-setting-mox',
        element: <MassageSettingMox />,
      },
      {
        path: 'service/massage-control',
        element: <MassageControl />,
      },
      {
        path: 'service/immersion-mode',
        element: <ImmersionMode />,
      },
      {
        path: '/device-binding',
        element: <DeviceBinding />,
      },
      {
        path: 'device/management',
        element: <DeviceManagement />,
      },
      {
        path: 'device/network-config',
        element: <DeviceNetworkConfig />,
      },
      {
        path: 'device/pos-assist',
        element: <PosAssist />,
      },
      {
        path: 'device/issue-detect-tool',
        element: <IssueDetectTool />,
      },
      {
        path: 'service-record',
        element: <ServiceRecord />,
      },
      {
        path: 'service-record-detail',
        element: <MemberRecordDetail />,
      },
      {
        path: '/device-binding',
        element: <DeviceBinding />,
      },
      {
        path: 'help/home',
        element: <HelpHomePage />,
      },
      {
        path: 'help/help-feedback',
        element: <HelpFeedback />,
      },
      {
        path: 'help/issue-report',
        element: <IssueReport />,
      },
      {
        path: 'help/feedback-progress',
        element: <FeedbackProgress />,
      },
      {
        path: 'help/use-skills',
        element: <UseSkills />,
      },
      {
        path: 'help/version-update-notice',
        element: <VersionUpdateNotice />,
      },
      {
        path: 'help/iframe-content',
        element: <IframeContent />,
      },
      {
        path: 'ai-consultation',
        element: <AIConsultation />,
      },

      ...(['qa', 'pre', 'prod'].includes(__BUILD_ENV__)
        ? []
        : [
            {
              path: 'nav',
              element: <Nav />,
            },
          ]),
      {
        path: '*',
        element: <Navigate to="/home" replace={true} />,
      },
    ],
  },
];

export default routerConfig;
